import type { ReactNode } from 'react';
import { VisuallyHidden } from 'react-aria-components';

interface AccordionBadgeCountProps {
  count: number;
  label: ReactNode;
}

export function AccordionBadgeCount({
  count,
  label,
}: AccordionBadgeCountProps) {
  return (
    <>
      <span className="absolute -right-6 -top-0 flex h-5 min-w-5 items-center justify-center rounded-full border-2 border-success-border bg-success-surface px-1 text-xs font-bold text-success-text shadow-md">
        {count}
      </span>
      <VisuallyHidden>
        {label}
        {`: ${count}`}
      </VisuallyHidden>
    </>
  );
}
